<template>
  <el-dialog
    v-if="dialogVisible"
    title="逾期配置"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="cancelHandler"
  >
    <div class="container">
      <el-form :model="formData" :rules="rulesForm" ref="ruleForm" label-width="140px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="园区公司" prop="parkCompanyNo">
              <el-select
                placeholder="请选择园区公司"
                disabled
                v-model="formData.parkCompanyNo"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) of contractCompanyList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同类型" prop="contractType">
              <el-select v-model="formData.contractType" style="width: 100%">
                <el-option
                  v-for="(item, index) of contractTypeList"
                  :value="item.value"
                  :label="item.label"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="20">
              <el-col :span="6" style="margin-top: 8px">一次预警时间</el-col>
              <el-col :span="18">
                <el-form-item label="合同到期前" prop="firstWarnTip">
                  <el-select v-model="formData.firstWarnTip" style="width: 100%">
                    <el-option
                      v-for="(item, index) of contractOverdueDayList"
                      :value="item.value"
                      :label="item.label"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预警颜色" prop="firstWarnColor">
              <el-input type="color" v-model="formData.firstWarnColor" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="20">
              <el-col :span="6" style="margin-top: 8px">二次预警时间</el-col>
              <el-col :span="18">
                <el-form-item label="合同到期前" prop="secondWarnTip">
                  <el-select v-model="formData.secondWarnTip" style="width: 100%">
                    <el-option
                      v-for="(item, index) of contractOverdueDayList"
                      :value="item.value"
                      :label="item.label"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预警颜色" prop="secondWarnColor">
              <el-input type="color" v-model="formData.secondWarnColor" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到期预警颜色设置" prop="expiredColor">
              <el-input type="color" v-model="formData.expiredColor" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelHandler">取 消</el-button>
      <el-button type="primary" @click="confirmHandler">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import superviseOverdueDayContractApi from '@/api/park/superviseOverdueDayContract.js';
  export default {
    name: 'OverdueSettingDialog',
    data() {
      return {
        dialogVisible: false,
        contractTypeList: [], // 合同类型
        contractOverdueDayList: [], // 逾期天数
        contractCompanyList: [], // 园区公司
        formData: {
          expiredColor: '',
          firstWarnColor: '',
          firstWarnTip: '',
          secondWarnColor: '',
          secondWarnTip: '',
          parkCompanyNo: '',
          parkCompanyName: '',
          contractType: '',
        },
        rulesForm: {
          expiredColor: [{ required: true, message: '必填字段', trigger: ['change', 'blur'] }],
          firstWarnColor: [{ required: true, message: '必填字段', trigger: ['change', 'blur'] }],
          firstWarnTip: [{ required: true, message: '必填字段', trigger: ['change', 'blur'] }],
          secondWarnColor: [{ required: true, message: '必填字段', trigger: ['change', 'blur'] }],
          secondWarnTip: [{ required: true, message: '必填字段', trigger: ['change', 'blur'] }],
          parkCompanyNo: [{ required: true, message: '必填字段', trigger: ['change', 'blur'] }],
          contractType: [{ required: true, message: '必填字段', trigger: ['change', 'blur'] }],
        },
      };
    },
    mounted() {
      this.contractTypeList = this.dictListMap.SuperviseContractType;
      this.contractOverdueDayList = this.dictListMap.SuperviseContractOverdueDay;
      this.contractCompanyList = this.dictListMap.SuperviseContractCompany;
      // 默认值,如果有就会覆盖
      this.formData = {
        ...this.formData,
        parkCompanyNo: this.userInfo.companyCode,
        parkCompanyName: this.contractCompanyList.find(
          (item) => item.value == this.userInfo.companyCode
        )?.label,
      };
    },
    methods: {
      async openDialog(formData = {}) {
        this.formData = {
          ...this.formData,
          ...formData,
        };
        this.dialogVisible = true;
      },
      cancelHandler() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
      confirmHandler() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            const postData = {
              ...this.formData,
              // 手动添加几个字段
              departmentCode: this.userInfo.departmentCode,
              departmentName: this.userInfo.departmentName,
              companyCode: this.userInfo.companyCode,
              companyName: this.userInfo.companyName,
              adminFlag: this.userInfo.adminFlag,
            };
            const { data } = await this.$axios.post(
              superviseOverdueDayContractApi.CREATE_SETTING,
              postData
            );
            if (data.code == 0) {
              this.$message.success(data.msg);
              this.$repeatAlert('修改配置第二天生效');
              this.cancelHandler();
              this.$emit('refreshTable');
            } else {
              this.$message.error(data.msg);
            }
          } else {
            this.$message.error('请补充表单字段');
          }
        });
      },
    },
  };
</script>

<style></style>
